import * as THREE from "three";

export const R = 2;
const D = Math.PI / 180;

export const ll = (lat, lon, r = R) => {
  const phi = (90 - lat) * D;
  const th = (lon + 180) * D;
  return new THREE.Vector3(
    -r * Math.sin(phi) * Math.cos(th),
    r * Math.cos(phi),
    r * Math.sin(phi) * Math.sin(th)
  );
};

export const PLACES = {
  italia: { lat: 42.5, lon: 12.5, name: "Italia" },
  russia: { lat: 58, lon: 56, name: "Russia" },
  algeria: { lat: 31, lon: 3, name: "Algeria" },
  libia: { lat: 27, lon: 17, name: "Libia" },
  egitto: { lat: 26.5, lon: 30, name: "Egitto" },
  congo: { lat: -1, lon: 15, name: "Congo" },
  mozambico: { lat: -12, lon: 40.5, name: "Mozambico" },
  qatar: { lat: 25.3, lon: 51.2, name: "Qatar" },
  usa: { lat: 30, lon: -92, name: "USA" },
  azerbaigian: { lat: 40.4, lon: 49.9, name: "Azerbaigian" },
};

export const ROUTES = {
  transmed: [[32.9, 3.3], [34.6, 8.2], [36.9, 10.9], [37.6, 12.6], [38.2, 15.6], [40.6, 16], [42.5, 12.8]],
  qatar: [[25.6, 51.8], [26.4, 56.6], [22, 60], [14, 52], [12.4, 43.6], [20, 38.4], [27.5, 34], [30.5, 32.4], [33.4, 27], [35.8, 18], [37.4, 15.4], [39.5, 12.6], [42.9, 10.5]],
  algeriaLng: [[36.9, 6.9], [38, 9.4], [39.6, 11.6], [42.9, 10.5]],
  usa: [[29.5, -92], [25.2, -84], [25.5, -76], [31, -55], [35, -30], [36.2, -9], [36, -5.4], [37.4, 0], [38.2, 6], [39.6, 11.6], [42.9, 10.5]],
};

const slerp = (a, b, t) => {
  const ang = a.angleTo(b);
  if (ang < 1e-6) return a.clone();
  const s = Math.sin(ang);
  return a.clone().multiplyScalar(Math.sin((1 - t) * ang) / s).add(b.clone().multiplyScalar(Math.sin(t * ang) / s));
};

export function arcCurve(a, b, lift = 0.3) {
  const va = ll(a.lat, a.lon, 1);
  const vb = ll(b.lat, b.lon, 1);
  const pts = [];
  for (let i = 0; i <= 64; i++) {
    const t = i / 64;
    pts.push(slerp(va, vb, t).multiplyScalar(R * (1.01 + lift * Math.sin(Math.PI * t))));
  }
  return new THREE.CatmullRomCurve3(pts);
}

export function routeCurve(wps, h = 1.008) {
  const pts = [];
  for (let i = 0; i < wps.length - 1; i++) {
    const a = ll(wps[i][0], wps[i][1], 1);
    const b = ll(wps[i + 1][0], wps[i + 1][1], 1);
    for (let k = 0; k < 10; k++) pts.push(slerp(a, b, k / 10).multiplyScalar(R * h));
  }
  const last = wps[wps.length - 1];
  pts.push(ll(last[0], last[1], R * h));
  return new THREE.CatmullRomCurve3(pts);
}

let _glow;
export function glowTex() {
  if (_glow) return _glow;
  const c = document.createElement("canvas");
  c.width = c.height = 128;
  const g = c.getContext("2d");
  const grd = g.createRadialGradient(64, 64, 0, 64, 64, 64);
  grd.addColorStop(0, "rgba(255,255,255,1)");
  grd.addColorStop(0.25, "rgba(255,255,255,0.55)");
  grd.addColorStop(1, "rgba(255,255,255,0)");
  g.fillStyle = grd;
  g.fillRect(0, 0, 128, 128);
  _glow = new THREE.CanvasTexture(c);
  return _glow;
}

export const clamp01 = (v) => Math.max(0, Math.min(1, v));
export const ease = (p) => 1 - Math.pow(1 - p, 4);
